<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="subtitle-1">Supplier Commission Receipts</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="itineraryItem"
            v-on="on"
            fab
            dark
            color="primary"
            @click="onCreateNew"
            small
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Supplier Commission Receipt</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          mobile-break-point="1264"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <supplier-commission-receipt-edit-dialog
      v-model="selectedItem"
      :show="showReceiptDialog"
      @close="showReceiptDialog = false"
      @input="onInput"
    />
    <v-row v-if="debug">
      <v-col>
        <code>{{ supplierCommissionReceipts }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import SupplierCommissionReceiptEditDialog from "./SupplierCommissionReceiptEditDialog";
import { removeGQLTypename } from "../../../../helpers";
const LIST_QUERY = gql`
  query supplierCommissionReceipts(
    $filter: SupplierCommissionReceiptFilterType
  ) {
    supplierCommissionReceipts(filter: $filter) {
      edges {
        node {
          id
          amount
          notes
          paymentDate
          paymentType
          reference
          serviceName
          supplierName
          itineraryReference
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createSupplierCommissionReceipt(
    $input: SupplierCommissionReceiptInput!
  ) {
    createSupplierCommissionReceipt(input: $input) {
      id
      amount
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateSupplierCommissionReceipt(
    $input: SupplierCommissionReceiptInput!
  ) {
    updateSupplierCommissionReceipt(input: $input) {
      id
      amount
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteSupplierCommissionReceipt($id: ID!) {
    deleteSupplierCommissionReceipt(id: $id) {
      id
    }
  }
`;
export default {
  name: "supplier-commission-receipt-list",

  props: {
    hideTitle: {
      type: Boolean,
      default: () => false,
    },
    itineraryItem: {
      type: Object,
      default: () => null,
    },
  },

  components: { DefaultListActions, SupplierCommissionReceiptEditDialog },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Payment Date",
          value: "paymentDate",
          name: "paymentDate",
        },
        {
          text: "Amount",
          value: "amount",
          name: "amount",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
          align: "center",
        },
      ],
      selectedItem: null,
      showReceiptDialog: false,
    };
  },

  computed: {
    items() {
      return this.supplierCommissionReceipts &&
        this.supplierCommissionReceipts.edges
        ? this.supplierCommissionReceipts.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onEditItem(payload) {
      this.selectedItem = { ...payload };
      this.showReceiptDialog = true;
    },
    onCreateNew() {
      this.selectedItem = { amount: 0, paymentType: "" };
      this.showReceiptDialog = true;
    },
    onInput(payload) {
      this.onSave(payload);
    },
    onSave(payload) {
      this.showReceiptDialog = false;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      const input = { ...payload };
      if (this.itineraryItem) {
        input.itineraryItemId = this.itineraryItem.id;
      }
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: { ...input } },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: { filter: this.getFilters() },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Supplier Commission Receipt Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
              variables: { filter: this.getFilters() },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Task Status Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    getFilters() {
      const f = {};
      if (this.itineraryItem) {
        f.group_id_eq = this.itineraryItem.id;
      }
      return f;
    },
  },
  apollo: {
    supplierCommissionReceipts: {
      query: LIST_QUERY,
      variables() {
        return {
          filter: { ...this.getFilters() },
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/supplier-commission-receipts/SupplierCommissionReceiptList.vue